export const selectors = {
	popupContainer: '.popup-container',
	popup: '.popup',
	popupClose: '.popup__close',
	popupCtr: '.popup__content',
	popupVideos: '.popup iframe',
	youTubeContainer: '.youtube',
	selfHostedVideo: 'video',
};

export const classes = {
	visibleClass: 'visible',
	popupOpen: 'popup-open',
};
